//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { IntegracoesContext } from "../../context/IntegracoesContext";
import { loadIntegrationsService } from "../../services";
import updateIntegrationService from "../../services/updateIntegrationService";
import { LoadingContext } from "../../../../shared/context/LoadingContext"



//--------------- EXPORTAÇÃO DO COMPONENTE MAIN ---------------//
export default function ModalCreateIntegration() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { leads } = useContext(IntegracoesContext);
    const { integrations, setIntegrations } = useContext(IntegracoesContext); // Estado que armazena a lista de Tags
    const { isOpenModalIntegration, setIsOpenModalIntegration } = useContext(IntegracoesContext);
    const { formDataModalIntegration, setFormDataModalIntegration } = useContext(IntegracoesContext); // Estado que armazena se Tag deve ser deletada
    const { isLoading, setIsLoading } = useContext(LoadingContext);


    //--------- FUNÇÃO ASSÍNCRONA CONFIRMAR DELEÇÃO --------//
    // Nesta função, é deletada a Tag selecionada do Banco de Dados via API.
    const handleUpdateIntegration = async () => {
        const response = await updateIntegrationService(formDataModalIntegration);
        if (response) {
            setFormDataModalIntegration(null);
            setIsOpenModalIntegration(false);
            handleRefreshIntegrations();
        }
    };



    //-------- FUNÇÃO ASSÍNCRONA CARREGAR TAGS ----------//
    // Nesta função, é requisitado à API as INTEGRAÇÕES armazenadas.
    // AS INTEGRAÇÕES retornadas pela API são armazenadas no Estado "integrations" .
    async function handleRefreshIntegrations() {
        setIsLoading(true);
        const response = await loadIntegrationsService();
        if (response) {
            setIntegrations(response.data);
        }
        setIsLoading(false);
    };



    //--------------- FUNÇÃO DE SELEÇÃO DA PLATAFORMA ---------------//
    const handleChangeStatus = (e) => {
        setFormDataModalIntegration({
            ...formDataModalIntegration,
            status: e.target.value === "true",
        });
    };


    //--------------- FUNÇÃO DE MUDANÇA DO NOME ---------------//
    const handleChangeNome = (e) => {
        setFormDataModalIntegration({
            ...formDataModalIntegration,
            nome: e.target.value,
        });
    };




    //--------------- FUNÇÃO CONTAR LEADS POR INTEGRAÇÃO ---------------//
    function contarLeadsPorIntegracao(integrationId) {
        if (!Array.isArray(leads) || !integrationId) return 0;

        return leads.filter(
            lead => lead.id_integracao === integrationId
        ).length;
    }



    //--------------- RETORNO DO COMPONENTE MAIN ---------------//
    return (
        <>

            {!isOpenModalIntegration ? null : (
                <>
                    {/* BACKDROP */}
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">

                        {/* MODAL */}
                        <div className="bg-surface-1 p-6 rounded shadow-md w-[90vw] max-w-md border border-white/[0.08]">

                            {/* TÍTULO */}
                            <h2 className="text-xl font-semibold mb-4">Editar Integração</h2>

                            {/* INPUT NOME */}
                            <div className="mb-4">
                                <label className="block text-ink-3 mb-2">Nome da Integração:</label>
                                <input
                                    type="text"
                                    value={formDataModalIntegration?.nome || ""}
                                    onChange={handleChangeNome}
                                    placeholder="Digite o nome da integração"
                                    className="w-full px-3 py-2 bg-surface-2 border border-white/[0.08] rounded text-white"
                                />
                            </div>{

                            /* SELECT STATUS */}
                            <div className="mb-4">
                                <label className="block text-ink-3 mb-2">Status:</label>
                                <select
                                    value={formDataModalIntegration?.status ? "true" : "false"}
                                    onChange={handleChangeStatus}
                                    className="w-full px-3 py-2 bg-surface-2 border border-white/[0.08] rounded text-white"
                                >
                                    <option value="true">Ativo</option>
                                    <option value="false">Inativo</option>
                                </select>
                            </div>

                            {/* INPUT PLATAFORMA */}
                            <div className="mb-4">
                                <label className="block text-ink-3 mb-2">Plataforma da Integração:</label>
                                <input
                                    type="text"
                                    value={formDataModalIntegration?.plataforma || ""}
                                    disabled
                                    className="w-full px-3 py-2 bg-surface-2 border border-white/[0.08] rounded text-white opacity-70"
                                />
                            </div>

                            {/* INPUT ENDPOINT_PATH */}
                            <div className="mb-4">
                                <label className="block text-ink-3 mb-2">Endpoint da Integração:</label>
                                <textarea
                                    type="text"
                                    value={formDataModalIntegration?.endpoint_path || ""}
                                    disabled
                                    className="w-full px-3 py-2 bg-surface-2 border border-white/[0.08] rounded text-white opacity-70 resize-none"
                                />
                            </div>

                            {/* INPUT TOTAL DE LEADS */}
                            <div className="mb-4">
                                <label className="block text-ink-3 mb-2">Total de Leads:</label>
                                <input
                                    type="text"
                                    value={contarLeadsPorIntegracao(formDataModalIntegration?.id) || 0}
                                    disabled
                                    className="w-full px-3 py-2 bg-surface-2 border border-white/[0.08] rounded text-white opacity-70"
                                />
                            </div>

                            {/* AÇÕES */}
                            <div className="flex justify-end gap-2">
                                <button
                                    onClick={() => setIsOpenModalIntegration(false)}
                                    className="bg-surface-3 hover:bg-surface-4 px-4 py-2 rounded"
                                >
                                    Cancelar
                                </button>
                                <button
                                    onClick={handleUpdateIntegration}
                                    className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded"
                                >
                                    Salvar
                                </button>
                            </div>

                        </div>
                    </div>
                </>
            )}

        </>
    )
}